// extracted by mini-css-extract-plugin
export default {"barContainer":"WorkPlanCard_barContainer__bt-Fx","badgeButtonContainer":"WorkPlanCard_badgeButtonContainer__ff0Xz"};